import { Button, Card, Space } from 'antd';
import AdminSidebar from '../Components/Sidebar';
import TableComponent from '../Components/TableComponent';
import { getSpecializedServices } from '../redux/slices/servicesSlice';
import { useNavigate } from 'react-router';
import { PlusCircleOutlined } from '@ant-design/icons';

function SpecializedServiceList() {
    const navigate = useNavigate()
    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
        },
        {
            title: 'Created At',
            dataIndex: 'created_at',
            key: 'created_at',
        },
        {
            title: 'Action',
            dataIndex: 'key',
            key: 'key',
            render: (_, record) => <a onClick={() => viewData(record?.key)}>View</a>,
        },
    ];

    const viewData = async (id) => {
        navigate(`/admin/specialized_services/${id}`)
    }

    const createSpecializedService = () => {
        navigate('/admin/specialized_services/create')
    }

    return (
        <>
            <AdminSidebar renderContent={
                <Card
                    title="Specialized Services"
                    style={{ marginBottom: 24 }}
                    extra={
                        <Space>
                            <Button icon={<PlusCircleOutlined />} onClick={createSpecializedService}>
                                Create Specialized Service
                            </Button>
                        </Space>
                    }
                >
                    <TableComponent
                        listData={getSpecializedServices}
                        columns={columns}
                        placeholder="Search Specialized Services..."
                    />
                </Card>
            } />
        </>
    );
}

export default SpecializedServiceList;